import React from 'react'
import useContentStack from '@/hooks/useContentStack'
import { CONTENT_STACK_TYPES, ANALYTICS } from '@/store/Constants'
import { useNextStage } from '@/hooks/useNextStage'
import useAnalytics from '@/hooks/useAnalytics'

const { BUTTONS, SCREENS } = ANALYTICS

export function ExitHpCloudConnection({ children, setVisibility, onClose }) {
  const { dispatchDeclinedStage } = useNextStage()

  const { fireButtonClick, fireModalWindowDisplayed } = useAnalytics(
    SCREENS.PRINTER_SETUP_COMPLETE
  )

  const { pageData } = useContentStack({
    content_type: CONTENT_STACK_TYPES.exit_hp_cloud_connection
  })

  fireModalWindowDisplayed()

  const closeClickHandler = () => {
    onClose()
    fireButtonClick(BUTTONS.CLOSE)
    setVisibility(false)
  }
  const exitWithoutConnecting = () => {
    fireButtonClick(BUTTONS.CANCEL_SETUP)
    dispatchDeclinedStage()
  }

  return (
    <>
      {children({
        data: pageData,
        buttonClicks: [exitWithoutConnecting],
        onClose: closeClickHandler,
        alignment: {
          content: 'center'
        }
      })}
    </>
  )
}
